import TextareaComponents from './Textarea.vue';

const TextArea = {
    install:function(Vue) {
        Vue.component('TextArea', TextareaComponents)
    }
}

export default TextArea;